import React from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProblemSection() {
  return <section className="bg-light py-28 md:py-32 px-4" data-id="element-179">
      <div className="max-w-[1100px] mx-auto flex flex-col items-center text-center" data-id="element-180">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-textDark mb-16" data-id="element-181">
          Estás sobreviviendo… pero lo llamas crecimiento.
        </h2>

        <div className="flex flex-col items-start text-left gap-6 mb-20 w-full max-w-2xl mx-auto" data-id="element-182">
          <div className="flex items-start gap-4" data-id="element-183">
            <Check className="text-accent shrink-0 mt-1" size={24} data-id="element-184" />
            <span className="text-lg md:text-xl text-textDark font-medium" data-id="element-185">
              Tu agenda está llena, pero tu negocio no crece en proporción.
            </span>
          </div>
          <div className="flex items-start gap-4" data-id="element-186">
            <Check className="text-accent shrink-0 mt-1" size={24} data-id="element-187" />
            <span className="text-lg md:text-xl text-textDark font-medium" data-id="element-188">
              Tu negocio depende demasiado de ti — si paras, se para.
            </span>
          </div>
          <div className="flex items-start gap-4" data-id="element-189">
            <Check className="text-accent shrink-0 mt-1" size={24} data-id="element-190" />
            <span className="text-lg md:text-xl text-textDark font-medium" data-id="element-191">
              Tomas decisiones cansada, y sabes que no son tus mejores
              decisiones.
            </span>
          </div>
          <div className="flex items-start gap-4" data-id="element-192">
            <Check className="text-accent shrink-0 mt-1" size={24} data-id="element-193" />
            <span className="text-lg md:text-xl text-textDark font-medium" data-id="element-194">
              Sientes que haces mucho, pero avanzas poco.
            </span>
          </div>
          <div className="flex items-start gap-4" data-id="element-195">
            <Check className="text-accent shrink-0 mt-1" size={24} data-id="element-196" />
            <span className="text-lg md:text-xl text-textDark font-medium" data-id="element-197">
              En el fondo, sabes que podrías operar mejor.
            </span>
          </div>
        </div>

        <p className="font-serif text-2xl md:text-4xl text-textDark font-bold mb-16 leading-relaxed" data-id="element-198">
          No es falta de capacidad.
          <br data-id="element-199" />
          Te sobra carga mal diseñada.
        </p>

        <CTAButton className="w-full md:w-auto" data-id="element-200">
          QUIERO VER QUÉ ELIMINAR
        </CTAButton>
      </div>
    </section>;
}